/* eslint-disable no-bitwise */
export default {
  methods: {
    $diffDates(from, to) {
      return this.$moment(from).startOf('day').diff(this.$moment(to).startOf('day'), 'days');
    },
    $isAfter(date, item) {
      return this.$moment(item).startOf('day').diff(this.$moment(date).startOf('day'), 'days') >= 0;
    },
    $isSame(date, item) {
      return this.$moment(item).startOf('day').isSame(this.$moment(date).startOf('day'));
    },
    $getDaysFromNow(count) {
      let days = count;
      const arrDays = [];
      let day = this.$moment();

      while (days) {
        arrDays.push(day.toISOString());
        day = this.$moment(day).subtract(1, 'days');
        days -= 1;
      }

      return arrDays;
    },
    $uniqueId() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16));
    },
  },
};
